module.exports = __webpack_public_path__ + "media/newstyle/images/info-pink-68da90805c5f28bff3a3d656abdac4e9.svg";